import { useQuery } from 'react-query';
import { apiNames, post } from '@general/api/shared';

export const fetchMessagesAccessToken = () =>
    post({
        apiName: apiNames.DEALS,
        endpoint: `chat-tokens`,
        addVersion: false,
        overrideHeaders: true,
    });

// fetch example for ref
// no requestHeaders needed
// const res = await fetch(`https://deals.icsc.test/chat-tokens`, {
//     method: 'POST',
//     credentials: 'include',
//     // headers: requestHeaders,
// });
// const { data } = await res.json();

const fetchAccessToken = async () => {
    try {
        const res = await fetchMessagesAccessToken();
        return res.data.data;
    } catch (e) {
        console.log(e);
        throw new Error(`Error retrieving access token.`);
    }
};

const useMessagingAccessToken = ({ isEnabled }) =>
    useQuery('messagingAccessToken', fetchAccessToken, {
        // token expires in an hour
        refetchInterval: 61 * 60 * 1000, // 61 appears to fix issues with not reconnecting
        enabled: isEnabled,
        cacheTime: Infinity,
        staleTime: Infinity,
        refetchOnWindowFocus: true,
        refetchOnMount: false,
        refetchOnReconnect: true,
    });

export default useMessagingAccessToken;
